import { defaultColorPalette } from './brandingThemes';

export enum LOCALE {
  US = 'es-US',
  IN = 'en-IN',
  ES = 'es-ES',
  DE = 'de-DE',
  FR = 'fr-FR',
  JP = 'ja-JP',
  KR = 'ko-KR',
  IT = 'it-IT',
  BR = 'pt-BR',
}

export enum CURRENCY {
  USD = 'USD',
  EUR = 'EUR',
  KRW = 'KRW',
  INR = 'INR',
  AUD = 'AUD ',
  BZR = 'BZR ',
  HKD = 'HKD ',
  JPY = 'JPY',
}

export const PASSWORD_RULES = [
  '10 characters long',
  'Contains at least one number',
  'Contains at least one uppercase character',
  'Contains at least one special character',
];

export const GRID_ROW_STYLES = {
  borderBottom: `1px solid ${defaultColorPalette.border}`,
  pb: 2,
  mb: 2,
};

export const MAX_TIME_INACTIVE = 900000; // 15 mins
export const ONE_MINUTE = 60000;
export const TEN_SECONDS = 10000;
export const ACCOUNT_STALE_TIME = 300000; // 5 minute

export const googlePlayStoreLink =
  'https://play.google.com/store/apps/details?id=com.oneadvisor.production&hl=en_US&gl=US';
export const appleAppStoreLink =
  'https://apps.apple.com/us/app/1advisor/id6451777691';
export const CONTACT_PHONE_NUMBER = '+18667751926';
